import { SRM_TICKET_SUGGESTION_COMPONENT_ID, type SrmTicketSuggestionItemModel } from '@libs/services/models';
import type { MarkupItemModel, MultiStepFormItemModel, SelectInputModel, SelectTreeInputModel, StepItemModel } from '@libs/form/models';

export const SrmFieldRequiredMarkupItem: MarkupItemModel = {
  type: 'markup',
  content: '<p><strong>*</strong> Pflichtfeld</p>',
};

export const HintRequired: string = '* Pflichtfeld';

// Request reason step
export const SrmCustomerNumberSelectItem: SelectInputModel = {
  type: 'select',
  name: 'customer_number',
  label: 'Kundennummer',
  hint: HintRequired,
  attributes: {
    required: true,
  },
  options: [],
};

export const SrmRequestReasonSelectTreeItem: SelectTreeInputModel = {
  type: 'selectTree',
  name: 'category',
  label: 'Anfrage bzw. Reklamationsgrund',
  emptyOption: 'Bitte wählen',
  hint: HintRequired,
  attributes: {
    required: true,
  },
  options: [],
};

export const SrmTicketSuggestionItem: SrmTicketSuggestionItemModel = {
  type: 'external',
  componentId: SRM_TICKET_SUGGESTION_COMPONENT_ID,
};

export const SrmCreateStepRequestReason: StepItemModel = {
  type: 'step',
  name: 'requestReason',
  title: 'Anliegen',
  items: [
    SrmCustomerNumberSelectItem,
    SrmRequestReasonSelectTreeItem,
  ],
  submit: {
    type: 'submit',
    items: [
      {
        name: 'next',
        label: 'weiter',
      },
    ],
  },
};

export const SrmCreateStepRequestDetails: StepItemModel = {
  type: 'step',
  name: 'requestDetails',
  title: 'Details',
  description: '',
  items: [],
  submit: {
    type: 'submit',
    items: [
      {
        name: 'prev',
        label: 'zurück',
        theme: 'text',
      },
      {
        name: 'next',
        label: 'weiter',
      },
    ],
  },
};

export const SrmCreateStepSummary: StepItemModel = {
  type: 'step',
  name: 'summary',
  title: 'Zusammenfassung',
  hideInPreview: true,
  items: [
    {
      type: 'preview',
      hideStepTitle: true,
    },
  ],
  submit: {
    type: 'submit',
    items: [
      {
        name: 'prev',
        label: 'zurück',
        theme: 'text',
      },
      {
        name: 'next',
        label: 'senden',
      },
    ],
  },
};

export const SrmCreateStepSuccess: StepItemModel = {
  type: 'step',
  name: 'success',
  title: 'Danke',
  hideInPreview: true,
  items: [
    {
      type: 'success',
      title: 'Vielen Dank für Ihre Anfrage',
      message: `Ihre Anfrage ist bei uns eingegangen. Wir werden uns schnellstmöglich bei Ihnen melden.`,
      action: {
        name: 'restart',
        theme: 'text',
        label: 'Weitere Anfrage starten.',
      },
    },
  ],
  submit: {
    type: 'submit',
    items: [
      {
        name: 'done',
        label: 'zur Übersicht',
      },
    ],
  },
};

export const SrmCreateForm: MultiStepFormItemModel = {
  type: 'form',
  name: 'srm',
  title: 'Wie können wir Ihnen behilflich sein?',
  isLinear: true,
  items: [
    SrmCreateStepRequestReason,
    SrmCreateStepRequestDetails,
    SrmCreateStepSummary,
    SrmCreateStepSuccess,
  ],
};
